var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1446_12652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 27H33V9H3V27ZM32.0621 26.1H3.93787V9.9H32.0739L32.0621 26.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0129 13.8825C14.7292 13.3875 13.3048 13.3594 11.9976 13.7981C11.2766 14.0231 10.6729 14.5069 10.3153 15.1538C10.0047 15.8119 10.075 16.5769 10.497 17.1731C10.8018 17.6063 11.2415 17.9381 11.7514 18.1294C12.8593 18.4894 13.9964 18.7425 15.1571 18.8888C15.4443 18.9338 15.7022 19.0688 15.9015 19.2713C16.0539 19.4344 16.1184 19.6481 16.0891 19.8619C16.0363 20.2163 15.8194 20.5256 15.5029 20.7113C15.1571 20.8913 14.7643 20.9813 14.3716 20.9644C13.7972 21.0094 13.2227 20.8856 12.7245 20.61C12.4607 20.4356 12.2438 20.1994 12.1031 19.9181C12.0152 19.7156 11.9449 19.5075 11.8804 19.2994L10.1219 19.4456C10.1629 19.8956 10.2802 20.34 10.4736 20.7563C10.6201 21.0263 10.796 21.2794 10.9894 21.5156C11.3001 21.8306 11.687 22.0669 12.1207 22.1963C12.5603 22.3425 13.0175 22.4269 13.4806 22.4494C13.9496 22.5056 14.4185 22.5056 14.8874 22.4494C15.3505 22.3931 15.8018 22.2975 16.2473 22.1681C16.6811 21.9938 17.0621 21.7238 17.361 21.375C17.5428 21.1163 17.6893 20.835 17.7948 20.5369C17.9003 20.1881 17.9238 19.8169 17.871 19.4569C17.8417 19.1306 17.7538 18.8156 17.6072 18.5231C17.2731 17.9606 16.7045 17.5669 16.0422 17.4375C15.1336 17.3025 14.2368 17.1 13.3575 16.8356C13.0469 16.7625 12.7479 16.6388 12.4783 16.4756C12.3317 16.3744 12.2438 16.2056 12.2497 16.0313C12.2555 15.8569 12.32 15.6938 12.4255 15.5531C12.6307 15.3056 12.9179 15.1313 13.2403 15.0638C13.4865 15.0075 13.7327 14.9681 13.9847 14.9569C14.2778 14.9794 14.565 15.03 14.8464 15.0975C15.1102 15.1425 15.3446 15.2831 15.5029 15.4913C15.6787 15.7219 15.8077 15.9806 15.8956 16.2563L17.6541 16.1775C17.6014 15.1763 16.9683 14.2875 16.0129 13.8825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9906 13.5V18.6412L21.1829 13.5H19.3071V22.4944H21.1829V17.37L23.9906 22.4944H25.8663V13.5H23.9906Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1446_12652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 18,
    fill: "white",
    transform: "translate(3 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSn);
export default __webpack_public_path__ + "static/media/sn.fdc834523fa9e9b42b070f1ab1d296c3.svg";
export { ForwardRef as ReactComponent };